const ORDERS = {
  ORDERS: '/orders',
  ORDER_CREATE: '/order/create',
  ORDER_DELETE: '/order/delete/:identifier',
  ORDER_EDIT: '/order/edit/:identifier'
} as const

export default ORDERS
